import { translate, useLocale } from "../localization";
import React, { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./Dashboard.scss";

import Filters from "../components/dashboard/Filters";
//import DashboardTrendsChart from "../components/dashboard/DashboardTrendsChart";


import { useAnalytics } from "../context/AnalyticsContext";
import { usePageMetadata } from "../context/PageMetadataContext";
import Statistics from "../components/dashboard/DashboardStatistics";
import GridHeader from "../components/dashboard/GridHeader";
import SortToggleButton from "../components/SortToggleButton";
import Insight from "../components/dashboard/Insight";
import { useNavigate } from "react-router-dom";
import { AppButton } from "../components/ui";
import AnalyticsModeNotice from "../components/dashboard/AnalyticsModeNotice";
import { isNewAnalyticsEnabled } from "../services/AnalyticsReadAPI";

const Dashboard = () => {
  const locale = useLocale();
  const navigate = useNavigate();

  const {
    insights, sortInsights, activeInsightSort, sessions, statistics, refreshAnalytics,
    analyticsLoading, analyticsRefreshing, analyticsError, lastFetchedAt,
  } = useAnalytics();
  const { setTitle, setShowTitleInHeader } = usePageMetadata();

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowTitleInHeader(true);
    setTitle(translate("Dashboard"));
    refreshAnalytics().catch(() => {});
  }, [refreshAnalytics, setShowTitleInHeader, setTitle, locale]);

  const hasInsights = Boolean(insights && insights.length > 0);
  const isLoading = analyticsLoading || analyticsRefreshing || (!lastFetchedAt && !analyticsError);
  const isEmpty = !analyticsError && !hasInsights && !sessions?.length;

  return (
    <div className="dashboard">
      <div className="content">
        <AnalyticsModeNotice error={analyticsError} />
        <div className="overview-header">
          <h3>{translate("Overview")}</h3>
          <Filters variant="compact" />
        </div>
        <div className="overview-section">
          {statistics ? (
            <>
              <Statistics />

              {/* Visualization aligned to the same rails as Overview */}
              {/*<div className="dash-viz">
                <DashboardTrendsChart title="Activity" insights={insights || []} />
              </div>*/}
            </>
          ) : isLoading ? (
            <div className="dashboard-loading-state" role="status">
              <CircularProgress color="inherit" aria-label={translate("Loading analytics")} />
              <span>{translate("Loading analytics...")}</span>
            </div>
          ) : isEmpty ? (
            <div className="dashboard-empty-state">
              <h2>{translate("Launch a new Experience to begin")}</h2>
              <AppButton onClick={() => navigate("/")}>{translate("Home")}</AppButton>
            </div>
          ) : null}
        </div>

        {hasInsights && (
          <div className="insights-section">
            <h3>{translate("Insights")}</h3>

            <div className="insights-table dashboard-data-table">
              <GridHeader>
                <div className="grid-column medium">{translate("Environment")}</div>
                <div className="grid-column wide">{translate("Question")}</div>
                <div className="grid-column medium">
                  <SortToggleButton
                    attribute="responseCount"
                    sortFunction={sortInsights}
                    activeSort={activeInsightSort}
                  />{translate("Completed")}</div>
                <div className="grid-column narrow">
                  <SortToggleButton
                    attribute="meanScore"
                    sortFunction={sortInsights}
                    activeSort={activeInsightSort}
                  />{translate("Score")}</div>
              </GridHeader>

              <div className="insights-list app-row-list">
                {insights.map((insight) => (
                  <Insight key={isNewAnalyticsEnabled ? `${insight.experienceId}:${insight.insightId}` : insight.insightId} insight={insight} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
